/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useState } from "react";
import { Col, Row } from "components/Grid";
import { FieldArray, Formik } from "formik";
import Icon from "components/Icon";
import Colors from "constants/Colors";
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import { ActionContainer, InlineLabel, Line, ListContent } from "./styles";
import { Label, ModalConfirmDelete } from '@fitinsur/components';

const fitinsur = new FitinsurAPI();


const ListDetail = ({ hasDelete, listDocuments, document, idOperation, columns, isClient, nameArray, permissions, onHistoryClick, hiddenTrash }) => {
  const authContext = useContext(GlobalAuthContext);
  const loading = useContext(GlobalLoaderContext);
  const mc = new MessageCenter();
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [url, setUrl] = useState(null);

  fitinsur.setAuthToken(authContext.token);

  function handleRmvAttach(idOperation, idDocument) {
    loading.start();

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestWordingDelAttach(idOperation, idDocument)
      .then(data => data.json())
      .then(resp => {
        if (resp.ret_code !== 200) {
          mc.error(resp.ret_msg_details);
          loading.stop();
          return;
        } else {
          listDocuments();
        }
      }).catch(err => {
        mc.error("An error happened, please try again: " + err);
        loading.stop();
      });
  };

  const renderFlowClient = () => {
    if (nameArray === 'supportDocuments') return (
      <Icon
        disabled={!hasDelete}
        onClick={() => hasDelete && handleRmvAttach(idOperation, document.idDocument)}
        name="trash"
        style={!hasDelete ? opacity : null}
      />
    )
  }

  useEffect(() => {
    if (document.documentName) {
      const simpleUrl = document.url.split('?');
      const queryUrl = simpleUrl[0] + '/' + document.documentName + '?' + simpleUrl[1];
      setUrl(queryUrl)
    } else {
      setUrl(document.url)
    }
  },
    [document])

  return (
    <>
      <Formik>
        <FieldArray
          name="listDetail"
          render={() =>
            <span>
              <Row>
                <Col md={columns[0].col} className="pl-0">
                  <InlineLabel>
                    {columns[0].title}
                  </InlineLabel>
                  <Label textColor={Colors.GRAY[0]}>
                    {document.documentName}
                  </Label>
                </Col>
                <Col md={columns[1].col} className="pl-0">
                  <InlineLabel>
                    {columns[1].title}
                  </InlineLabel>
                  <Label textColor={Colors.GRAY[0]}>
                    {document.version}
                  </Label>
                </Col>
                <Col md={columns[2].col} className="pl-0">
                  <InlineLabel>
                    {columns[2].title}
                  </InlineLabel>
                  <Label textColor={Colors.GRAY[0]}>
                    {document.documentType}
                  </Label>
                </Col>
                <Col md={columns[3].col} className="pl-0">
                  <InlineLabel>
                    {columns[3].title}
                  </InlineLabel>
                  <Label textColor={Colors.GRAY[0]}>
                    {document.uploadedBy}
                  </Label>
                </Col>
                <Col md={columns[4].col} className="pl-0">
                  <InlineLabel>
                    {columns[4].title}
                  </InlineLabel>
                  <Label textColor={Colors.GRAY[0]}>
                    {new Date(document.uploadedDate).toLocaleDateString('pt-br')}
                  </Label>
                </Col>
                <Col md={columns[5].col} className="pl-0">
                  <InlineLabel>
                    {columns[5].title}
                  </InlineLabel>
                  <Label textColor={Colors.GRAY[0]}>
                    {document.documentExpireDate ? new Date(document.documentExpireDate).toLocaleDateString('pt-br') : '-'}
                  </Label>
                </Col>
                <Col md={columns[6].col} className="px-0">
                  <ActionContainer>
                    <Icon
                      onClick={() => window.open(url, '_blank')}
                      name="search"
                      style={icon}
                    />
                    {onHistoryClick && (
                      <Icon
                        onClick={() => onHistoryClick(document)}
                        name="history"
                        style={icon}
                      />
                    )}
                    {!isClient ?
                      !hiddenTrash && (
                        <Icon
                          disabled={!hasDelete || permissions.DOCUMENT_GENERAL}
                          onClick={() => hasDelete && setShowDeleteConfirmation(true)}
                          name="trash"
                          style={!hasDelete ? opacity : null}
                        />
                      )
                      : renderFlowClient()}
                  </ActionContainer>
                </Col>
              </Row>
              <Row>
                <Col className="pl-2 pr-2">
                  <Line />
                </Col>
              </Row>
            </span>
          }
        />
      </Formik>

      <ModalConfirmDelete
        show={showDeleteConfirmation}
        onModalClose={() => setShowDeleteConfirmation(false)}
        onConfirm={() => handleRmvAttach(idOperation, document.idDocument)}
      />

    </>

  );
};

const spaceLabel = {
  allignItens: "center",
};

const icon = {
  color: Colors.GRAY[6],
};

const opacity = {
  color: Colors.GRAY[5],
  opacity: 0.5,
  cursor: "not-allowed",
};

const opacityAllowed = {
  color: Colors.GRAY[5],
  opacity: 0.5,
};

export default ListDetail;
